import React from 'react';

import PaginatedTable from '../../commonComponents/util/PaginatedTable';

import { formatDate, formatCurrency } from '../../../lib/utils';
import { TransactionTypes } from '../../../lib/constants';

export default class OutsideTransactionTable extends React.Component {

    getTableRow(transaction) {
        return <tr className="table-row" key={transaction.transactionId}>
            <td data-label="Select">
                <div className={`custom-check-container name-check-container ${!transaction.canVoid ? "disabled" : ""}`}>
                    <input type="checkbox" id={`name-${transaction.transactionId}`} className="custom-check input"
                        checked={this.props.selectedTrans.includes(transaction.transactionId)} onChange={(e) => this.props.selectTransaction(e.target.checked, transaction.transactionId)}
                        disabled={!transaction.canVoid} />
                    <label htmlFor={`name-${transaction.transactionId}`} className="secondary-text input" />
                </div>
            </td>
            <td data-label="ReferenceNum" key="ReferenceNum">
                <p>{transaction.referenceNumber}</p>
            </td>
            <td data-label="Amount" key="Amount">
                {this.formatAmount(transaction.type, transaction.amount)}
            </td>
            <td data-label="Date" key="Date">
                <p>{formatDate(transaction.date)}</p>
            </td>
            <td data-label="Description" key="Description">
                <p>{transaction.description}</p>
            </td>
            <td data-label="Source" key="Source">
                <p>{transaction.source}</p>
            </td>
            <td data-label="Status" key="Status">
                {this.formatStatus(transaction.status)}
            </td>
            {this.props.canUpdate && <td data-label="Action" style={{ maxWidth: "200px" }}>
                <div className="transactions-table-actions flex flex-justify">
                    <span
                        className="link-text small-text text-center input mr-8"
                        onClick={() => this.props.onUpdateTransaction(transaction)}
                    >Edit Transaction</span>
                    {!!transaction.reconciliationId && (
                        <span
                            className="link-text small-text text-center input mr-8"
                            onClick={() => this.props.onUpdateReconciliationStatus(transaction)}
                        >Change Reconciliation Status</span>
                    )}
                    {!!transaction.reconciliationNote && (
                        <span
                            className="link-text small-text text-center input"
                            onClick={() => this.props.onClickReconciliationNote(transaction)}
                        >Note</span>
                    )}
                </div>
            </td>}
        </tr>
    }

    formatAmount(type, amount) {
        return type === TransactionTypes.Withdrawal ? <p className="bold-text error-text">-{formatCurrency(amount, this.props.isIsraeli)}</p>
            : <p className="bold-text approved-text">+{formatCurrency(amount, this.props.isIsraeli)}</p>;
    }

    formatStatus(status) {
        switch (status) {
            case "Cleared":
                return <p><i className="icon-left icon-check approved-text" />Cleared</p>;
            case "Outstanding":
                return <p><i className="icon-left icon-refresh approved-text" />Outstanding</p>;
            case "Void":
                return <p><i className="icon-left icon-close approved-text" />Void</p>;
            default:
                break;
        }
    }

    render() {
        const columns = [
            { title: '', sortable: false, id: 'select' },
            { title: 'Reference #', sortable: true, id: 'reference' },
            { title: 'Amount', sortable: true, id: 'amount', defaultDirection: 'Descending' },
            { title: 'Date', sortable: true, id: 'date' },
            { title: 'Description', sortable: false, id: 'description' },
            { title: 'Source', sortable: false, id: 'details' },
            { title: 'Status', sortable: true, id: 'status' }
        ];
        if(this.props.canUpdate) {
            columns.push({ title: 'Action', sortable: false, id: 'action' });
        }

        return <PaginatedTable
            name="outside transactions"
            page={this.props.page}
            totalCount={this.props.data.totalCount}
            resultsView={this.props.resultsView}
            sort={this.props.sort}
            loading={this.props.loading}
            success={this.props.success}
            renderRow={this.getTableRow.bind(this)}
            columns={columns}
            records={this.props.data.records || []}
            sortData={this.props.updateTable}
            changeDataView={this.props.updateTable}
            loadData={this.props.getTransactions} />
    }
}


// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/OutsideTransactionsTable.jsx